// extracted by mini-css-extract-plugin
export default {"checkboxradio":"CheckboxRadio_checkboxradio__7F7BS"};